import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PercentageFieldText } from 'src/components/mui-overrides/Percentage';

interface Props {
  disabled?: boolean;
}

export const RentalReturnField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <PercentageFieldText
      disabled={disabled}
      hideHelperText={true}
      size="small"
      label={t('dashboard.assets.addedit.main.rentalincome.fields.rentalreturn')}
      fieldName="rentalDetails.rentalReturn"
      formik={formik}
    />
  );
};
